



















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import CreateBookingRequest from '@/models/Bookings/CreateBookingRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import BookingDto from '@/models/Bookings/BookingDto';
import { LocationListModule } from '@/store/modules/locationList';
import { BookingListModule } from '@/store/modules/bookingList';
import PageNames from '@/router/PageNames';

@Component({
    name: 'BookingCreate'
})
export default class BookingCreate extends GiganautVueDialog {
 
  entity: BookingDto = new BookingDto();
  dates: string[] = [];
  datesFailedValidation = false;

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new BookingDto();
      this.datesFailedValidation = false;
      if (LocationListModule.locations.length === 0) {
        LocationListModule.searchLocations();
      }
      if (AgencySettingsModule.branches.length === 0) {
        AgencySettingsModule.getBranches();
      }
        if (AgencySettingsModule.agencyUsers.length === 0) {
        AgencySettingsModule.getAgencyUsers();
      }
    }
  }

  get departments() {
    return this.entity.location.departments;
  }

  get locations() {
    return LocationListModule.locations;
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get agencyUsers() {
    return AgencySettingsModule.agencyUsers;
  }

  get loading() {
    return BookingListModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    if (this.dates.length === 0) {
      this.datesFailedValidation = true;
      return;
    }
    
    const request = new CreateBookingRequest()
    request.branchId = this.entity.branch.id;
    request.companyId = this.entity.location.companyId;
    request.locationId = this.entity.location.id;
    request.departmentId = this.entity.department.id;
    request.ownerId = this.entity.owner.id;
    request.isTest = this.entity.isTest;
    if (request.isTest) {
      request.testEmailAddresses = this.entity.testEmailAddresses;
    }
    //Add the dates
    for (let index = 0; index < this.dates.length; index++) {
      const dateString = this.dates[index];
      request.dates.push(new Date(`${dateString}T12:00`));
    }
    
    await BookingListModule.createBooking(request)
    if (BookingListModule.newBookingId !== '') {
      this.$router.push({ name: PageNames.AgencyBookingDetails, params: { bookingid: BookingListModule.newBookingId } });
    }
    this.dialog = false;
  }
}
